// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GxYzH","rootMobile":"styles_rootMobile__39CUC"};